export const mfaOtpSetup = ($http: HttpApi) => ({
  provision: (username: string, tenantSlug: string) => $http.$post('/authentication/mfa_otp_setup/provision', {
    body: {
      username,
      tenant_slug: tenantSlug,
    },
  }),
  verify: (username: string, tenantSlug: string, token: string) => $http.$post('/authentication/mfa_otp_setup/verify', {
    body: {
      username,
      tenant_slug: tenantSlug,
      token,
    },
  }),
});
